// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1YuTz","author":"Table_author__3oz0-","authorImage":"Table_authorImage__23fWT","unreadRow":"Table_unreadRow__vz6TA"};